import { useEffect } from "react";
import { ListChecks, UserPlus, Receipt, Send, Mail, Voicemail, Users } from "lucide-react";

/* One-tap actions that open in-platform panels; keyboard shortcuts when not typing. */
export const QuickActions = ({ go, manager, buttons = true }) => {
  const acts = [["campaigns", "Campaigns", ListChecks, "C"], ["newcust", "New customer", UserPlus, "N"], ["quote", "Quote / checkout", Receipt, "Q"], ["send", "Send info", Send, "S"],
    ["mail", "Email", Mail, "E"], ["voicemail", "Voicemail", Voicemail, "V"], ...(manager ? [["teamdialer", "Team dialer", Users, "T"]] : [])];
  useEffect(() => {
    const h = (e) => {
      if (e.metaKey || e.ctrlKey || e.altKey || /input|textarea|select/i.test(e.target.tagName) || e.target.isContentEditable) return;
      const a = acts.find(x => x[3] === e.key.toUpperCase());
      if (a && e.shiftKey) { e.preventDefault(); go(a[0]); }
    };
    window.addEventListener("keydown", h);
    return () => window.removeEventListener("keydown", h);
  });
  if (!buttons) return null;
  return (
    <div className="flex gap-1.5 overflow-x-auto no-scrollbar pb-0.5" data-testid="quick-actions">
      {acts.map(([k, l, I, key]) => (
        <button key={k} onClick={() => go(k)} title={`Shift + ${key}`} className="shrink-0 h-9 px-3 rounded-lg bg-white border border-slate-200 hover:border-blue-400 hover:bg-blue-50 text-xs font-semibold text-slate-700 flex items-center gap-1.5 transition-colors" data-testid={`qa-${k}`}>
          <I className="w-3.5 h-3.5 text-blue-600" />{l}<kbd className="hidden lg:inline text-[9px] text-slate-400 border border-slate-200 rounded px-1">⇧{key}</kbd>
        </button>))}
    </div>
  );
};
